import React from 'react'

const Pdf = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/pdf',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <rect fill={primaryColor} x={1} y={1} width='90%' height='90%' rx={2} />
      <path
        d='M16.175 12.881c-.315.439-.745.67-1.25.67-.684 0-1.478-.432-2.368-1.285a26.908 26.908 0 0 0-4.963 1.588c-.471.997-.922 1.8-1.34 2.39-.577.808-1.073 1.184-1.565 1.184a.902.902 0 0 1-.544-.183c-.586-.439-.665-.928-.628-1.26.102-.917 1.235-1.874 3.367-2.85.845-1.854 1.65-4.138 2.13-6.046-.562-1.221-1.107-2.806-.71-3.736a1.191 1.191 0 0 1 1.08-.728c.285 0 .538.125.715.35.165.211.666.848-.087 4.013.759 1.566 1.832 3.16 2.861 4.253.738-.135 1.372-.202 1.888-.202.882 0 1.415.206 1.634.628.18.35.106.758-.22 1.214zm-8.025-.28a28.083 28.083 0 0 1 3.653-1.137c-.76-.882-1.517-1.983-2.15-3.117a40.366 40.366 0 0 1-1.503 4.254zm1.217-9.027c-.012.003-.03.006-.054.015-.055.018-.099.048-.137.137-.145.338-.03.981.192 1.671.183-1.19.085-1.696 0-1.823zM4.46 16.09c-.005.051-.021.188.242.39.084-.027.573-.25 1.485-1.933-1.203.676-1.692 1.23-1.727 1.543zm9.304-4.029c.458.351.864.545 1.163.545.133 0 .305-.031.479-.274a.81.81 0 0 0 .128-.233c-.067-.036-.27-.112-.771-.112-.284 0-.621.025-1 .074z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Pdf
